import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Checkout() {
  return (
    <Row>
      <Col xs={{ span: 9, offset: 3 }} className="text-left">
        <h1>Checkout</h1>
      </Col>
    </Row>
  );
}

export default Checkout;
